import React, { Component, Fragment} from 'react'
import { ChromePicker } from 'react-color';
import PropTypes from 'prop-types';
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
   
        color: {
          width: '36px',
          height: '20px',
          borderRadius: '2px',
          //background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
        },
        swatch: {
          padding: '2px',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
         float: 'left',
          marginRight: '10px',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
          bottom: '39px',
        //   left: '-50%',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
  
  });

 class ColorPicker extends Component {
        constructor(props){
            super(props);
            this.state = {
                displayColorPicker: false,
            }
          }  
    
        handleClick = () => {
            this.setState({ displayColorPicker: !this.state.displayColorPicker })
        };

        handleClose = () => {
            this.setState({ displayColorPicker: false })
        };

        handleChange = (color) => {
            this.props.handleChange(color)
        };

    render() {
      
        const { classes } = this.props  
        const  color  = this.props.backgroundColor
        return (
            <Fragment>
            
                <div className={classes.swatch } onClick={ this.handleClick }>
                    <div className={classes.color } style={{ background:color}}  />
                </div>
                { this.state.displayColorPicker ? <div className={classes.popover }>
                <div className={classes.cover } onClick={ this.handleClose }/>
                <ChromePicker disableAlpha={true} color={ color }  onChange={ this.handleChange } />
                </div> : null }
            </Fragment>
        )
    }
}
ColorPicker.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(ColorPicker)